
import { Link } from "react-router-dom";
import { PiggyBank, Shield, Lock, CreditCard } from "lucide-react";

// Define this logo separately so it can be reused in other components
export const LainasampoLogo = () => (
  <div className="flex items-center group">
    <div className="bg-blue-500 bg-opacity-20 p-2 rounded-full group-hover:bg-opacity-30 transition-all">
      <PiggyBank className="h-8 w-8 text-blue-300" />
    </div>
    <span className="ml-2 text-2xl font-bold font-serif tracking-wide bg-gradient-to-r from-blue-200 to-blue-100 bg-clip-text text-transparent">Lainasampo.fi</span>
  </div>
);

const FooterLogo = () => {
  return (
    <div className="flex flex-col">
      <Link 
        to="/" 
        className="inline-block mb-4"
        aria-label="Lainasampo.fi etusivu - Lainavertailu ja kilpailutus"
        title="Lainasampo.fi - Löydä edullisin laina helposti"
      >
        <LainasampoLogo />
      </Link>
      <p className="text-blue-200 mb-6">
        Löydä edullisin laina helposti! Kilpailutamme eri pankkien tarjoukset puolestasi - säästä aikaa ja rahaa.
      </p>
      
      <div className="flex items-center space-x-3 mb-4 group hover:bg-blue-700/30 p-2 rounded-md transition-all duration-300 w-full">
        <div className="bg-green-500/20 p-2 rounded-full">
          <Shield className="h-5 w-5 text-green-400 group-hover:text-green-300 transition-colors" />
        </div>
        <span className="text-sm text-blue-100 group-hover:translate-x-1 transition-transform">Luotettava vertailupalvelu</span>
      </div>
      <div className="flex items-center space-x-3 mb-4 group hover:bg-blue-700/30 p-2 rounded-md transition-all duration-300 w-full">
        <div className="bg-green-500/20 p-2 rounded-full">
          <Lock className="h-5 w-5 text-green-400 group-hover:text-green-300 transition-colors" />
        </div>
        <span className="text-sm text-blue-100 group-hover:translate-x-1 transition-transform">Tietoturvallinen asiointi</span>
      </div>
      <div className="flex items-center space-x-3 group hover:bg-blue-700/30 p-2 rounded-md transition-all duration-300 w-full">
        <div className="bg-green-500/20 p-2 rounded-full">
          <CreditCard className="h-5 w-5 text-green-400 group-hover:text-green-300 transition-colors" />
        </div>
        <span className="text-sm text-blue-100 group-hover:translate-x-1 transition-transform">Nopea lainapäätös</span>
      </div>
    </div>
  );
};

export default FooterLogo;
